<template>
  <router-link
    :to="{ name: toName, params: params, query: query }"
    class="dark-link f-16 font-weight-regular disable-text-decoration"
  >
    <v-icon
      v-if="append === false"
      :size="14"
      class="ico-neg-45-deg pb-1 primary-link"
    >
      $dropdown
    </v-icon>
    {{ label }}
    <v-icon
      v-if="append === true"
      :size="14"
      class="ico-arrow-right pl-1 primary-link"
    >
      $dropdown
    </v-icon>
  </router-link>
</template>

<script>
export default {
    name: 'ReturnLink',
    props: {
        label: {
            required: true,
            type: String
        },
        toName: {
            required: true,
            type: String
        },
        params: {
            required: false,
            type: Object,
            default: () => { return {}; }
        },
        append: {
            default: false,
            type: Boolean
        },
        query: {
            type: Object,
            default: () => { }
        }
    }
};
</script>

<style scoped></style>
